import React, { useState } from 'react';
import * as XLSX from 'xlsx';

import {
  RemoveAllCandidateButton,
  AddCandidateButton,
  CandidateListRow,
  FormHeader,
  PlusIcon,
  TableCell,
  TextInput,
  XIcon,
  MinusIcon,
  ExcelFileUploaderContainer,
  FileUploaderLabel,
  FileUploaderInput,
  FormSection,
  ErrorMessage,
  InputContainer,
} from './styles';
import { isValidEmail } from 'functions/stringValidation';

const CandidatesList = ({ candidateList, setCandidateList, isDemoDepartment }) => {
  const emptyCandidateItem = { email: '', name: '', isValidEmail: true, isValidName: true };
  const [fileUploaderError, setFileUploaderError] = useState('');

  const checkEmailValidation = (index, value) => {
    let updatedList = [...candidateList];
    updatedList[index].isValidEmail = (isDemoDepartment && value === '') || isValidEmail(value);
    setCandidateList(updatedList);
  };
  const setCandidateEmail = (index, value) => {
    let updatedList = [...candidateList];
    if (!updatedList[index].isValidEmail)
      updatedList[index].isValidEmail = (isDemoDepartment && value === '') || isValidEmail(value);
    updatedList[index].email = value;
    setCandidateList(updatedList);
  };

  const setCandidateName = (index, value) => {
    let updatedList = [...candidateList];
    updatedList[index].isValidName = value !== '';
    updatedList[index].name = value;
    setCandidateList(updatedList);
  };
  const deleteCandidate = (index) => {
    if (candidateList.length === 1) {
      setCandidateList([emptyCandidateItem]);
      return;
    }
    let updatedList = [...candidateList];
    updatedList.splice(index, 1);
    setCandidateList(updatedList);
  };
  const parseXlxsForUsers = (file) => {
    if (
      !file ||
      (file.type !== 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' &&
        file.type !== 'application/vnd.ms-excel')
    )
      return;

    file.arrayBuffer().then(function (data) {
      var workbook = XLSX.read(data);
      var workData = XLSX.utils.sheet_to_json(workbook.Sheets[workbook.SheetNames[0]]);

      var emailHeadingAlternatives = ['Email', 'e-mail', 'E-mail', 'email'];
      var nameHeadingAlternatives = ['Name', 'Names', 'names', 'name'];

      //rename keys to be called name/email
      workData.map(function (row, rowIndex) {
        Object.keys(row).map(function (key) {
          var emailIndex = emailHeadingAlternatives.indexOf(key);
          var nameIndex = nameHeadingAlternatives.indexOf(key);

          if (emailIndex != -1) {
            workData[rowIndex].email = workData[rowIndex][key];
          } else if (nameIndex != -1) {
            workData[rowIndex].name = workData[rowIndex][key];
          }
        });
      });

      // if the correct name for the keys are still missing, show error
      let errorMsg = '';
      workData.map(function (row) {
        if (!row.email || !row.name) {
          errorMsg = 'We could not find two headings called Email and Name';
        }
      });
      if (errorMsg) {
        setFileUploaderError(errorMsg);
        return;
      } else if (fileUploaderError) setFileUploaderError('');

      let updatedList = [...candidateList];
      updatedList = updatedList.filter((item) => !(item.name === '' && item.email === ''));

      // Push data into receivers
      workData.map((data) => {
        if (data.name && data.email)
          updatedList.push({
            name: data.name,
            isValidName: true,
            email: data.email,
            isValidEmail: isValidEmail(data.email),
          });
      });
      if (updatedList.length === 0) updatedList.push(emptyCandidateItem);
      setCandidateList(updatedList);
    });
  };
  const renderCandidateList = () => {
    return candidateList.map((candidate, index) => {
      return (
        <CandidateListRow key={index}>
          <TableCell padding="5px" widthPercentage="48%" verticalTop>
            <InputContainer>
              <TextInput
                id="candidatesEmailInput"
                placeholder={isDemoDepartment ? 'E-mail' : 'E-mail*'}
                value={candidate.email}
                onChange={(e) => setCandidateEmail(index, e.target.value)}
                onBlur={(e) => checkEmailValidation(index, e.target.value)}
              ></TextInput>
              {!candidate.isValidEmail && (
                <ErrorMessage small noMarginBottom>
                  Please enter a valid Email
                </ErrorMessage>
              )}
            </InputContainer>
          </TableCell>
          <TableCell noPadding paddingX widthPercentage="44%" verticalTop>
            <InputContainer>
              <TextInput
                placeholder="Name*"
                value={candidate.name}
                onChange={(e) => setCandidateName(index, e.target.value)}
              ></TextInput>
              {!candidate.isValidName && (
                <ErrorMessage small noMarginBottom>
                  Please enter a name
                </ErrorMessage>
              )}
            </InputContainer>
          </TableCell>
          <TableCell padding="5px" widthPercentage="8%" verticalTop>
            <XIcon marginTop onClick={() => deleteCandidate(index)} />
          </TableCell>
        </CandidateListRow>
      );
    });
  };
  return (
    <FormSection id="candidatesSection">
      <FormHeader>Send test to:</FormHeader>
      {renderCandidateList()}
      <CandidateListRow>
        <AddCandidateButton
          id="addNewCandidateButton"
          onClick={() => setCandidateList([...candidateList, { ...emptyCandidateItem }])}
        >
          <PlusIcon />
        </AddCandidateButton>
        <RemoveAllCandidateButton onClick={() => setCandidateList([emptyCandidateItem])}>
          <MinusIcon /> Remove all
        </RemoveAllCandidateButton>
      </CandidateListRow>
      <ExcelFileUploaderContainer>
        <FileUploaderLabel>Mass send via excel file. Two headings called Email and Name must exist.</FileUploaderLabel>
        <FileUploaderInput onChange={(e) => parseXlxsForUsers(e.target.files[0])}></FileUploaderInput>
        {fileUploaderError && <ErrorMessage>{fileUploaderError}</ErrorMessage>}
      </ExcelFileUploaderContainer>
    </FormSection>
  );
};

export default CandidatesList;
